var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 465.49 310.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-3 {\n        fill: #000823;\n      }\n\n      .cls-4 {\n        fill: #225601;\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.99,
    y: 59.8,
    width: 355.52,
    height: 191.12
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 465.49,
    height: 310.37
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "108.33 209.01 103.71 209.01 103.71 206.01 116.34 206.01 116.34 209.01 111.75 209.01 111.75 227.02 108.33 227.02 108.33 209.01"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M121.14,221.35v-15.34h3.42v15.55c0,1.86.96,2.76,2.73,2.76s2.76-.9,2.76-2.76v-15.55h3.3v15.34c0,3.78-2.13,5.97-6.12,5.97s-6.09-2.22-6.09-5.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "139.21 206.01 143.5 206.01 148.87 219.85 148.87 206.01 151.96 206.01 151.96 227.02 148.48 227.02 142.27 210.9 142.27 227.02 139.21 227.02 139.21 206.01"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 157.97,
    y: 206.01,
    width: 3.42,
    height: 21.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.67,221.71v-.9h3.21v.9c0,1.56.96,2.7,2.76,2.7s2.76-1.05,2.76-2.7c0-1.98-.78-2.61-3.87-4.05-3.75-1.77-4.77-3.51-4.77-6.36,0-3.3,2.13-5.58,6.03-5.58s5.91,2.25,5.91,5.64v.57h-3.24v-.54c0-1.62-.87-2.76-2.67-2.76-1.62,0-2.61,1.08-2.61,2.61,0,1.8.87,2.43,3.93,3.9,3.78,1.77,4.71,3.54,4.71,6.48,0,3.42-2.16,5.7-6.15,5.7s-6-2.25-6-5.61"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 184.11,
    y: 206.01,
    width: 3.42,
    height: 21.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M202.08,222.94h-5.55l-.84,4.08h-3.24l4.65-21.01h4.62l4.71,21.01h-3.51l-.84-4.08ZM201.45,219.97l-2.16-10.38-2.13,10.38h4.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "211.36 206.01 215.65 206.01 221.02 219.85 221.02 206.01 224.11 206.01 224.11 227.02 220.63 227.02 214.42 210.9 214.42 227.02 211.36 227.02 211.36 206.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M237.64,221.35v-9.66c0-3.81,2.22-5.97,6.21-5.97s6.21,2.16,6.21,5.97v9.66c0,3.81-2.22,5.97-6.21,5.97s-6.21-2.16-6.21-5.97M246.65,221.5v-9.96c0-1.83-.99-2.82-2.79-2.82s-2.79.99-2.79,2.82v9.96c0,1.83.99,2.82,2.79,2.82s2.79-.99,2.79-2.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "255.74 206.01 259.16 206.01 259.16 224.02 266.52 224.02 266.52 227.02 255.74 227.02 255.74 206.01"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 271.47,
    y: 206.01,
    width: 3.42,
    height: 21.01
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "279.81 206.01 283.32 206.01 286.71 223 290.13 206.01 293.41 206.01 288.84 226.99 284.37 226.99 279.81 206.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "298.33 206.01 309.43 206.01 309.43 209.01 301.75 209.01 301.75 214.87 307.96 214.87 307.96 217.87 301.75 217.87 301.75 224.02 309.43 224.02 309.43 227.02 298.33 227.02 298.33 206.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M322.16,221.35v-9.66c0-3.81,2.22-5.97,6.21-5.97s6.21,2.16,6.21,5.97v9.66c0,3.81-2.22,5.97-6.21,5.97s-6.21-2.16-6.21-5.97M331.16,221.5v-9.96c0-1.83-.99-2.82-2.79-2.82s-2.79.99-2.79,2.82v9.96c0,1.83.99,2.82,2.79,2.82s2.79-.99,2.79-2.82"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 340.25,
    y: 206.01,
    width: 3.42,
    height: 21.01
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "349.68 206.01 353.1 206.01 353.1 224.02 360.45 224.02 360.45 227.02 349.68 227.02 349.68 206.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M71.81,170.8l-3.38-24.56c0-.26.95-.69,1.04-.09,3.47,24.65,14.06,23.43,22.04,23.43,9.55,0,16.4-5.55,16.4-12.41,0-17.01-38.79-12.41-38.79-31.76,0-12.32,10.15-16.23,18.22-16.23,6.77,0,13.54.95,20.22.95l2.78,22.74c0,.35-1.04.17-1.04-.09-3.38-22.65-15.62-21.61-21.61-21.61-6.6,0-11.63,3.04-11.63,9.89,0,19.09,38.79,9.98,38.79,30.37,0,13.54-12.58,20.13-23,20.13-6.42,0-10.5-.78-17.27-.78h-2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120.58,147.98c0-13.97,9.29-23.95,23.17-23.95s23.34,9.98,23.34,23.95-9.37,23.87-23.34,23.87-23.17-9.89-23.17-23.87M159.03,147.89c0-12.84-5.64-22.39-15.27-22.39s-15.1,9.55-15.1,22.48,5.55,22.39,15.1,22.39,15.27-9.55,15.27-22.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M185.49,164.12c0,2.43.78,4.17,2.78,4.17,1.48,0,2.78-.95,4.34-2.95.26-.43,1.3.43,1.13.78-2.26,3.12-6.16,5.55-9.81,5.55-5.73,0-6.51-4.86-6.51-7.29v-46.86c0-5.12-.52-8.68-5.64-8.42-.43,0-.43-1.13-.09-1.22,3.65-.69,8.77-1.3,12.5-2,.87-.17,1.3-.09,1.3.61v57.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M211.88,164.12c0,2.43.78,4.17,2.78,4.17,1.48,0,2.78-.95,4.34-2.95.26-.43,1.3.43,1.13.78-2.26,3.12-6.16,5.55-9.81,5.55-5.73,0-6.51-4.86-6.51-7.29v-28.81c0-5.12-.52-8.68-5.64-8.42-.43,0-.43-1.13-.09-1.21,3.65-.69,8.77-1.3,12.5-2,.87-.17,1.3-.09,1.3.61v39.57Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "265.07 125.15 245.55 170.89 242.25 170.89 223.07 125.15 231.84 125.15 247.46 162.56 263.16 125.15 265.07 125.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M291.8,124.02c11.11,0,16.92,7.64,16.92,13.89,0,4.34-2.95,7.9-9.11,7.9h-24.13v1.65c0,8.68,5.38,19.44,17.62,19.44,7.64,0,12.32-5.38,15.97-11.28.26-.43,1.04.35.95.61-4.51,9.11-9.98,15.53-19.7,15.53-13.28,0-22.91-10.07-22.91-23.26,0-14.15,10.41-24.47,24.39-24.47M295.53,144.5c4.34,0,6.86-4.17,6.86-8.59,0-5.12-3.3-10.59-10.93-10.59-8.07,0-14.58,8.94-15.97,19.18h20.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M320.35,170.89v-35.41c0-5.12-.52-8.68-5.64-8.42-.43,0-.43-1.13-.09-1.22,3.65-.69,8.77-1.3,12.5-2,.87-.17,1.3-.09,1.3.61v9.29l2.43-2.43c5.03-5.03,6.16-7.38,10.93-7.38,2,0,4.77.87,6.16,2.26,2.52,2.52-.17,6.33-3.04,6.33-.78,0-1.56-.26-2.26-.95-1.65-1.65-3.38-3.38-5.21-3.38-.87,0-1.74.35-2.6,1.21l-6.42,6.34v35.15h-8.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M353.59,160.73c0-6.77,4.17-11.98,18.83-15.79,2.95-.78,6.34-1.48,10.15-2.17v-4.43c0-8.51-5.12-12.5-10.76-12.5-6.16,0-9.72,4.86-9.72,11.28,0,2.26-1.91,3.38-3.73,3.38s-3.82-1.13-3.82-3.47c0-7.81,13.63-13.02,19.87-13.02,8.07,0,16.23,2.43,16.23,15.1v25.17c0,2.43.78,4.17,2.78,4.17,1.48,0,2.78-.95,4.34-2.95.26-.43,1.3.43,1.13.78-2.26,3.12-6.08,5.55-9.72,5.55-5.73,0-6.51-4.86-6.51-7.29v-6.34h-.17c-1.91,6.07-7.2,13.54-15.53,13.54-7.29,0-13.36-4.25-13.36-11.02M382.58,155.01v-10.93c-3.91.61-7.12,1.39-9.72,2.17-10.93,3.56-11.54,8.85-11.54,12.32,0,5.21,4.17,8.59,8.94,8.59,5.99,0,10.07-4.86,12.32-12.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M233.83,76.54c-.94-.52-1.68-.26-2.3.5-2.98,3.44-7.11,6.17-11.12,8.14-.94.45-3.73,1.72-4.47,2.17-.66.38-1.35.83-2.08,1-1.03.21-2.14.01-3.19-.14-1.21-.23-2.5-.72-3.72-.92-.72-.13-1.4-.08-2.12-.13-1.35-.14-2.68-.12-4.06.03-4.11.32-8.07,1.97-11.39,4.37-3.2,2.14.58,2.01,2.28,2.28,6.03.74,11.28-.73,16.84-2.85.25-.04,4.83-2.42,3.74-.98-2.21,2.91-3.92,6.03-5.2,8.7-.1-.02-.19-.03-.29-.04-.63-.04-2.18.18-2.83.49-.94.47-1.77,1.15-2.39,2-1.21,1.53-1.6,3.5-1.63,5.42-.04,3.67,1.39,7.91,4.58,9.96,1.43.89,3.02,1,4.55.32h.02c1.8-.7,3-2.39,3.69-4.14,1.92-4.48.54-11.74-4.29-13.64,1.28-2.71,2.92-5.61,4.72-7.4,3.72-3.69,7.22-4.81,8.91-5.61,1.27-.6,2.48-.92,3.7-1.53.79-.41,1.39-.53.86.7-1.43,2.92-2.54,6.21-2.29,9.45.34,4.19,1.96,8.12,4.24,11.62.51.82,1.03,1.61,1.5,2.45.34.61.66,1.29.97,1.91.16.32.51.97.85.69.7-.89.58-2.38.72-3.45.41-3.54.02-7.08-.84-10.54-.86-3.58-4.1-9.27-3.6-12.76.18-1.13.98-1.98,1.76-2.76,1.02-1.05,2.2-1.98,3.32-2.92.92-.73,2.18-1.53.51-2.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M67.73,187.19c108.98-2.14,219.35-2.16,328.33,0-108.98,2.16-219.35,2.14-328.33,0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColor);
export default __webpack_public_path__ + "static/media/LogoColor.e57d9dc9f44b8cc64dd0da2cf3b0f668.svg";
export { ForwardRef as ReactComponent };